import React from 'react';

import Skel from '../skel';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import styles from './styles.css';

export default function HomologationErrorIndicator({ error, loading }) {
  if (error !== null) {
    return <Grid item sm={2}>
      <div className={styles.gridCell}>
        <Typography variant="subtitle2">
          Status
        </Typography>

        <Skel loading={loading}>
          <span style={{ color: error ? 'red' : 'green' }}>
            {error ? 'Não conforme' : 'Conforme'}
          </span>
        </Skel>
      </div>
    </Grid>;
  } else {
    return null;
  }
}
